import api from "../../config/client.axios.api";
import { TLogin } from "../../types";

export const loginApiRequest = async (loginInfo: TLogin) => {
  const response = await api.post(`/auth/authenticate`, loginInfo);
  return response.data;
};
